import getFormDetails from './getFormDetails';

const FormsRequests = {
	getFormDetails,
};

export default FormsRequests;
